/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointedIntermediaryViewModel } from './AppointedIntermediaryViewModel';
import {
    AppointedIntermediaryViewModelFromJSON,
    AppointedIntermediaryViewModelFromJSONTyped,
    AppointedIntermediaryViewModelToJSON,
} from './AppointedIntermediaryViewModel';
import type { ContributionSummaryViewModel } from './ContributionSummaryViewModel';
import {
    ContributionSummaryViewModelFromJSON,
    ContributionSummaryViewModelFromJSONTyped,
    ContributionSummaryViewModelToJSON,
} from './ContributionSummaryViewModel';
import type { GEPContributorViewModel } from './GEPContributorViewModel';
import {
    GEPContributorViewModelFromJSON,
    GEPContributorViewModelFromJSONTyped,
    GEPContributorViewModelToJSON,
} from './GEPContributorViewModel';
import type { GHUBPRODUCTCODE } from './GHUBPRODUCTCODE';
import {
    GHUBPRODUCTCODEFromJSON,
    GHUBPRODUCTCODEFromJSONTyped,
    GHUBPRODUCTCODEToJSON,
} from './GHUBPRODUCTCODE';
import type { IncomeViewModel } from './IncomeViewModel';
import {
    IncomeViewModelFromJSON,
    IncomeViewModelFromJSONTyped,
    IncomeViewModelToJSON,
} from './IncomeViewModel';
import type { InvestmentComponentsViewModel } from './InvestmentComponentsViewModel';
import {
    InvestmentComponentsViewModelFromJSON,
    InvestmentComponentsViewModelFromJSONTyped,
    InvestmentComponentsViewModelToJSON,
} from './InvestmentComponentsViewModel';
import type { InvestmentFeesViewModel } from './InvestmentFeesViewModel';
import {
    InvestmentFeesViewModelFromJSON,
    InvestmentFeesViewModelFromJSONTyped,
    InvestmentFeesViewModelToJSON,
} from './InvestmentFeesViewModel';
import type { PolicyValueDetailsViewModel } from './PolicyValueDetailsViewModel';
import {
    PolicyValueDetailsViewModelFromJSON,
    PolicyValueDetailsViewModelFromJSONTyped,
    PolicyValueDetailsViewModelToJSON,
} from './PolicyValueDetailsViewModel';
import type { RecurringInvestmentViewModel } from './RecurringInvestmentViewModel';
import {
    RecurringInvestmentViewModelFromJSON,
    RecurringInvestmentViewModelFromJSONTyped,
    RecurringInvestmentViewModelToJSON,
} from './RecurringInvestmentViewModel';
import type { RegularWithdrawalViewModel } from './RegularWithdrawalViewModel';
import {
    RegularWithdrawalViewModelFromJSON,
    RegularWithdrawalViewModelFromJSONTyped,
    RegularWithdrawalViewModelToJSON,
} from './RegularWithdrawalViewModel';

/**
 * 
 * @export
 * @interface ClientInvestmentDetailsViewModel
 */
export interface ClientInvestmentDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof ClientInvestmentDetailsViewModel
     */
    planNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInvestmentDetailsViewModel
     */
    investmentName: string;
    /**
     * 
     * @type {GHUBPRODUCTCODE}
     * @memberof ClientInvestmentDetailsViewModel
     */
    productCode: GHUBPRODUCTCODE;
    /**
     * 
     * @type {number}
     * @memberof ClientInvestmentDetailsViewModel
     */
    totalMarketValue: number;
    /**
     * 
     * @type {number}
     * @memberof ClientInvestmentDetailsViewModel
     */
    transactionsInProgress: number;
    /**
     * 
     * @type {Date}
     * @memberof ClientInvestmentDetailsViewModel
     */
    investmentInceptionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientInvestmentDetailsViewModel
     */
    nextFeeRecoveryDate: Date;
    /**
     * 
     * @type {InvestmentFeesViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    investmentFees: InvestmentFeesViewModel;
    /**
     * 
     * @type {ContributionSummaryViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    contributionSummary: ContributionSummaryViewModel;
    /**
     * 
     * @type {RegularWithdrawalViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    regularWithdrawal: RegularWithdrawalViewModel;
    /**
     * 
     * @type {InvestmentComponentsViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    investmentComponents: InvestmentComponentsViewModel;
    /**
     * 
     * @type {IncomeViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    income: IncomeViewModel;
    /**
     * 
     * @type {RecurringInvestmentViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    recurringInvestment: RecurringInvestmentViewModel;
    /**
     * 
     * @type {GEPContributorViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    gepContributor: GEPContributorViewModel;
    /**
     * 
     * @type {Array<AppointedIntermediaryViewModel>}
     * @memberof ClientInvestmentDetailsViewModel
     */
    appointedIntermediaries: Array<AppointedIntermediaryViewModel>;
    /**
     * 
     * @type {PolicyValueDetailsViewModel}
     * @memberof ClientInvestmentDetailsViewModel
     */
    policyValueDetails: PolicyValueDetailsViewModel;
}

/**
 * Check if a given object implements the ClientInvestmentDetailsViewModel interface.
 */
export function instanceOfClientInvestmentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "planNumber" in value;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "productCode" in value;
    isInstance = isInstance && "totalMarketValue" in value;
    isInstance = isInstance && "transactionsInProgress" in value;
    isInstance = isInstance && "investmentInceptionDate" in value;
    isInstance = isInstance && "nextFeeRecoveryDate" in value;
    isInstance = isInstance && "investmentFees" in value;
    isInstance = isInstance && "contributionSummary" in value;
    isInstance = isInstance && "regularWithdrawal" in value;
    isInstance = isInstance && "investmentComponents" in value;
    isInstance = isInstance && "income" in value;
    isInstance = isInstance && "recurringInvestment" in value;
    isInstance = isInstance && "gepContributor" in value;
    isInstance = isInstance && "appointedIntermediaries" in value;
    isInstance = isInstance && "policyValueDetails" in value;

    return isInstance;
}

export function ClientInvestmentDetailsViewModelFromJSON(json: any): ClientInvestmentDetailsViewModel {
    return ClientInvestmentDetailsViewModelFromJSONTyped(json, false);
}

export function ClientInvestmentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInvestmentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planNumber': json['PlanNumber'],
        'investmentName': json['InvestmentName'],
        'productCode': GHUBPRODUCTCODEFromJSON(json['ProductCode']),
        'totalMarketValue': json['TotalMarketValue'],
        'transactionsInProgress': json['TransactionsInProgress'],
        'investmentInceptionDate': (new Date(json['InvestmentInceptionDate'])),
        'nextFeeRecoveryDate': (new Date(json['NextFeeRecoveryDate'])),
        'investmentFees': InvestmentFeesViewModelFromJSON(json['InvestmentFees']),
        'contributionSummary': ContributionSummaryViewModelFromJSON(json['ContributionSummary']),
        'regularWithdrawal': RegularWithdrawalViewModelFromJSON(json['RegularWithdrawal']),
        'investmentComponents': InvestmentComponentsViewModelFromJSON(json['InvestmentComponents']),
        'income': IncomeViewModelFromJSON(json['Income']),
        'recurringInvestment': RecurringInvestmentViewModelFromJSON(json['RecurringInvestment']),
        'gepContributor': GEPContributorViewModelFromJSON(json['GepContributor']),
        'appointedIntermediaries': ((json['AppointedIntermediaries'] as Array<any>).map(AppointedIntermediaryViewModelFromJSON)),
        'policyValueDetails': PolicyValueDetailsViewModelFromJSON(json['PolicyValueDetails']),
    };
}

export function ClientInvestmentDetailsViewModelToJSON(value?: ClientInvestmentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PlanNumber': value.planNumber,
        'InvestmentName': value.investmentName,
        'ProductCode': GHUBPRODUCTCODEToJSON(value.productCode),
        'TotalMarketValue': value.totalMarketValue,
        'TransactionsInProgress': value.transactionsInProgress,
        'InvestmentInceptionDate': (value.investmentInceptionDate.toISOString()),
        'NextFeeRecoveryDate': (value.nextFeeRecoveryDate.toISOString()),
        'InvestmentFees': InvestmentFeesViewModelToJSON(value.investmentFees),
        'ContributionSummary': ContributionSummaryViewModelToJSON(value.contributionSummary),
        'RegularWithdrawal': RegularWithdrawalViewModelToJSON(value.regularWithdrawal),
        'InvestmentComponents': InvestmentComponentsViewModelToJSON(value.investmentComponents),
        'Income': IncomeViewModelToJSON(value.income),
        'RecurringInvestment': RecurringInvestmentViewModelToJSON(value.recurringInvestment),
        'GepContributor': GEPContributorViewModelToJSON(value.gepContributor),
        'AppointedIntermediaries': ((value.appointedIntermediaries as Array<any>).map(AppointedIntermediaryViewModelToJSON)),
        'PolicyValueDetails': PolicyValueDetailsViewModelToJSON(value.policyValueDetails),
    };
}

